import HNSColors from "../../../../ui library/HNSColors";
import useViewNavigationService from "../hooks/useViewNavigationService";

export default function ViewManagementLink({
  viewName,
  id,
  elementId,
  openInNewTab = true,
  children,
  className = "",
  activeClassName = "text-left underline",
  disabledClassName = "text-black no-underline",
  ...props
}) {
  const { hasPermissionForView, navigateToView } = useViewNavigationService();
  const canNavigate = hasPermissionForView(viewName);
  const linkElementId = elementId || `view-link-${viewName}-${id}`;

  const handleClick = (event) => {
    event.preventDefault();

    if (!canNavigate) {
      return;
    }

    navigateToView(viewName, id, { newTab: openInNewTab });
  };

  return (
    <button
      id={linkElementId}
      type="button"
      onClick={handleClick}
      disabled={!canNavigate}
      style={
        canNavigate
          ? {
              color: `var(--report-link-color, ${HNSColors.primary[500]})`,
              transition: "color 150ms ease",
            }
          : undefined
      }
      className={`${
        canNavigate ? activeClassName : disabledClassName
      } ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}
